/*
 * Copyright (c) 2018. Unconventional Software Corporation
 */

import {NgModule} from "@angular/core";
import {IonicModule} from "ionic-angular";
import {ProgramInformationListComponent} from "./program-information-list/program-information-list";
import {ScheduleMenuComponent} from "./schedule-menu/schedule-menu";
import {DayScheduleComponent} from "./day-schedule/day-schedule";
import {EntryDancersComponent} from "./entry-dancers-component/entry-dancers-component";
import {EntryDetailsComponent} from "./entry-details-component/entry-details-component";
import {EntryTimelineComponent} from "./entry-timeline-component/entry-timeline-component";
import {ErrorMessage} from "./error-message/error-message";
import {EventItem} from "./event-item/event-item";
import {EventListItem} from "./event-list-item/event-list-item";
import {EventMap} from "./event-map/event-map";
import {EventSchedule} from "./event-schedule/event-schedule";
import {FixedTimeListItem} from "./fixed-time-list-item/fixed-time-list-item";
import {HomeControlOptions} from "./home-control-options/home-control-options";
import {LandingButton} from "./landing-button/landing-button";
import {LoginForm} from "./login-form/login-form";
import {Logo} from "./logo/logo";
import {RoutineListItem} from "./routine-list-item/routine-list-item";
import {SignupForm} from "./signup-form/signup-form";
import {StatusIcon} from "./status-icon/status-icon";
import {StudioItemComponent} from "./studio-item-component/studio-item-component";
import {StudioIcon} from "./studio-icon/studio-icon";
// import { MedallionIconComponent } from './medallion-icon/medallion-icon';
import { AwardIconComponent } from './award-icon/award-icon';
import { ScoreIconComponent } from './score-icon/score-icon';
import {PasswordStrengthBarComponent} from "./password-strength-bar/password-strength-bar";
import {PasswordStrengthValidator} from "./password-strength-bar/password-strength-validator";
import { SearchResultComponent } from './search-result/search-result';

@NgModule({
  declarations: [
    DayScheduleComponent,
    EntryDancersComponent,
    EntryDetailsComponent,
    EntryTimelineComponent,
    ErrorMessage,
    EventItem,
    EventListItem,
    EventMap,
    EventSchedule,
    FixedTimeListItem,
    HomeControlOptions,
    LandingButton,
    // LoginForm,
    // MedallionIconComponent,
    Logo,
    PasswordStrengthBarComponent,
    PasswordStrengthValidator,
    ProgramInformationListComponent,
    RoutineListItem,
    ScheduleMenuComponent,
    ScoreIconComponent,
    SignupForm,
    StatusIcon,
    StudioIcon,
    StudioItemComponent,
    // MedallionIconComponent,
    AwardIconComponent,
    ScoreIconComponent,
    SearchResultComponent
  ],
  imports: [IonicModule],
  exports: [
    DayScheduleComponent,
    EntryDancersComponent,
    EntryDetailsComponent,
    EntryTimelineComponent,
    ErrorMessage,
    EventItem,
    EventListItem,
    EventMap,
    EventSchedule,
    FixedTimeListItem,
    HomeControlOptions,
    LandingButton,
    // MedallionIconComponent,
    // LoginForm,
    Logo,
    PasswordStrengthBarComponent,
    PasswordStrengthValidator,
    ProgramInformationListComponent,
    RoutineListItem,
    ScheduleMenuComponent,
    ScoreIconComponent,
    SignupForm,
    StatusIcon,
    StudioIcon,
    StudioItemComponent,
    // MedallionIconComponent,
    AwardIconComponent,
    ScoreIconComponent,
    SearchResultComponent
  ]
})
export class ComponentsModule {}



// WEBPACK FOOTER //
// ./src/components/components.module.ts